import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { ComponentProps } from '../utils/types';
import { StyledMenuItem } from './styles';

type MenuItemPropsInterface = React.ComponentProps<typeof StyledMenuItem> & {
  active?: boolean;
  loading?: boolean;
  icon: JSX.Element;
};

const MenuItem = React.forwardRef<HTMLButtonElement, MenuItemPropsInterface>(
  ({ loading, children, icon, ...restProps }, ref) => {
    return (
      <StyledMenuItem
        icon={loading ? <Skeleton height={24} width={24} /> : icon}
        {...restProps}
        ref={ref}
      >
        {loading ? <Skeleton height={24} width="100%" /> : children}
      </StyledMenuItem>
    );
  }
);

export type MenuItemProps = ComponentProps<typeof MenuItem>;
export default MenuItem;
